import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axiosClient from "../../api/axios";
import ClipLoader from "react-spinners/ClipLoader";

const StudiesList = () => {

  const [studies, setStudies] = useState([]);
  const [loading, setLoading] = useState(true);

  // Pagination params
  const [page, setPage] = useState(1);
  const limit = 6;
  const [total, setTotal] = useState(0);

  const fetchStudies = async () => {
    try {
      setLoading(true);
      const response = await axiosClient.get("/api/studies/", {
        params: { page, limit, search: "" },
      });

      setStudies(response.data.data);
      setTotal(response.data.total);
    } catch (error) {
      console.error("Failed to fetch studies", error);
    }finally {
      setLoading(false); 
    }
  };

  useEffect(() => {
    fetchStudies();
  }, [page]);

  const totalPages = Math.ceil(total / limit);

  if (loading) {
    return (
      <section
        className="feature-section ptb-100"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "60vh",
        }}
      >
        <ClipLoader color="#0d6efd" size={80} />
      </section>
    );
  }

  return (
    <>
      <section id="features" className="feature-section ptb-100">
        {studies?.map((study) => (
          <div key={study.id} className="container">
            <div className="row align-items-center justify-content-between">
              <div className="col-md-4">
                <div className="download-img">
                  <Link to={`/current-studies/${study.id}`}>
                    <img
                      src={study.image_url}
                      className="img-fluid"
                      style={{ borderRadius: "10px" }}
                    />
                  </Link>
                </div>
              </div>
              <div className="col-md-8">
                <div className="feature-contents section-heading">
                  <Link to={`/current-studies/${study.id}`}>
                    <h2>{study.title}</h2>
                  </Link>
                  <p style={{ fontSize: "1.2rem" }}>{study.description}</p>

                  <div className="mt-3">
                    <h5>You may qualify if you: </h5>
                    {study?.requirements?.map((val, index) => (
                      <p style={{ fontSize: "1.2rem" }} key={index}>
                        {val}
                      </p>
                    ))}
                  </div>

                  <div className="mt-3">
                    <h5>As a participant, you will receive: </h5>
                    {study?.compensations?.map((val, index) => (
                      <p style={{ fontSize: "1.2rem" }} key={index}>
                        {val}
                      </p>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="post-more pt-1 pb-4 mb-5 align-items-center justify-content-center d-flex">
              <Link
                to={`/current-studies/${study.id}`}
                className="btn solid-btn"
              >
                More Details <span className="ti-arrow-right"></span>
              </Link>
            </div>
          </div>
        ))}
      </section>

      {/* Pagination Controls */}
      {totalPages > 1 && (
        <div className="d-flex justify-content-center my-4">
          <button
            onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
            className="btn btn-outline-primary mx-2"
            disabled={page === 1}
          >
            Previous
          </button>
          <span className="align-self-center">
            Page {page} of {totalPages}
          </span>
          <button
            onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
            className="btn btn-outline-primary mx-2"
            disabled={page === totalPages}
          >
            Next
          </button>
        </div>
      )}
    </>
  );
};

export default StudiesList;
